import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { PropertyService } from 'src/app/property/property.service';
import { Property } from 'src/typings';

@Component({
  selector: 'app-property-selector',
  templateUrl: './property-selector.component.html',
  styleUrls: ['./property-selector.component.scss']
})
export class PropertySelectorComponent implements OnInit {
  properties: Property[] = [];

  filteredOptions: Property[] = [];

  constructor(private propertyService: PropertyService) {
    this.propertyService.getList().subscribe((list) => {
      this.properties = list;
      this.filteredOptions = list;
    });
  }

  @Input() control: UntypedFormControl = new UntypedFormControl('');

  public displayProperty(property: any) {
    if (property) {
      return property.description;
    }
    return;
  }

  ngOnInit(): void {
    this.control.valueChanges.subscribe((data) => {
      if (typeof data === 'string') {
        this.filteredOptions = this.properties.filter((prop) => {
          return prop.description.toUpperCase().includes(data.toUpperCase());
        });
      } else {
        this.filteredOptions = this.properties.filter((prop) => {
          return prop.description.toUpperCase().includes(data.description.toUpperCase());
        });
      }
    });
  }

  handleSelect(event: MatAutocompleteSelectedEvent) {
    if (typeof event.option.value === 'string') {
      this.propertyService.createProperty(event.option.value).subscribe((prop) => {
        this.control.setValue(prop);
      });
    }
  }
}
